import { I18n } from 'aws-amplify'
import { dictionary } from '../../../presentation/dictionary'

export const t = (key: any, defVal?: any) => {
  const { get } = I18n
  return get(key, defVal)
}

export const addLanguage = (language: string) => {
  I18n.setLanguage(language)
  I18n.putVocabularies(dictionary)
}
